import { atom } from "recoil";
export const modalOpenAtom = atom({
  key: "modalOpenAtom",
  default: false,
});
export const modalLoadingAtom = atom({
  key: "modalLoadingAtom",
  default: false,
});
export const modalStrictlyFormAtom = atom({
  key: "modalStrictlyFormAtom",
  default: false,
});
export const modalComponentAtom = atom({
  key: "modalComponentAtom",
  default: null,
});
export const modalFormValuesAtom = atom({
  key: "modalFormValuesAtom",
  default: null,
});
export const modalCallbacksAtom = atom({
  key: "modalCallbacksAtom",
  default: null,
});
export const modalExtraDataAtom = atom({
  key: "modalExtraDataAtom",
  default: null,
});
